// Inquiry submission via Web3Forms (https://web3forms.com) — no backend, no DNS,
// and it does not touch the domain's MX (Titan email stays intact). Submissions
// are emailed to the address tied to the access key. The Web3Forms access key is
// public by design; set REACT_APP_WEB3FORMS_ACCESS_KEY at build time.
const WEB3FORMS_ENDPOINT = "https://api.web3forms.com/submit";
// Web3Forms access keys are public by design (used client-side). The fallback
// keeps the form working in Git-built deploys where the env var isn't set.
const ACCESS_KEY =
    process.env.REACT_APP_WEB3FORMS_ACCESS_KEY ||
    "e79dd9c4-6b44-46e7-9416-ad54f225af59";

export const submitInquiry = async (payload) => {
    if (!ACCESS_KEY) {
        throw new Error("Missing Web3Forms access key");
    }

    const res = await fetch(WEB3FORMS_ENDPOINT, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify({
            access_key: ACCESS_KEY,
            from_name: "Jagruthi Stones Website",
            subject: `New export inquiry: ${payload.product_interest || "General"}`,
            ...payload,
        }),
    });

    const data = await res.json();
    if (!res.ok || !data.success) {
        throw new Error(data.message || "Submission failed");
    }
    return data;
};
